import Dispacher from "../Dispacher";
import ActionTypes from "./LoginActionTypes";

export const login = (item) => {
  Dispacher.dispatch({
    type: ActionTypes.LOGIN,
    item,
  });
};
